import React from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { PartnerType } from '../../../types/benefit';
import { PARTNER } from '../../../constants/define/translation';
import { ActionsColumn, IndexColumn, ImageColumn, PartnerColumn } from './columns';
import { appStyles } from '../../../styles';

interface PartnerTableProps {
  records: PartnerType[];
  onRefresh: () => void;
  setIsOpenModal: Function;
  setDataRecord: Function;
  handleChangePagePartner: Function;
  loading?: boolean;
  className?: string;
  isDraft?: boolean;
  pagination?: TablePaginationConfig;
}

const { Column } = Table;
export const PartnerTable = (props: PartnerTableProps) => {
  const { t } = useTranslation(PARTNER);
  const { pagination, records, loading, className } = props;
  return (
    <>
      <StyledTable
        dataSource={records}
        loading={loading}
        className={className}
        rowKey="index"
        pagination={pagination}
        summary={() => {
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={2} index={0}>
                  Total: {pagination?.total}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      >
        <Column
          title={t('table.title.index')}
          align="center"
          width={50}
          dataIndex="index"
          key="index"
          render={value => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.title')}
          align="center"
          width={50}
          dataIndex="title"
          key="title"
          render={(_, record: PartnerType) => <PartnerColumn record={record} />}
        />
        <Column
          title={t('table.title.logo')}
          align="center"
          width={50}
          dataIndex="title"
          key="title"
          render={(_, record: PartnerType) => <ImageColumn record={record} />}
        />
        <Column
          title={t('table.title.action')}
          align="center"
          key="action"
          width={100}
          render={(_, record: PartnerType) => <ActionsColumn total={records.length} record={record} {...props} />}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .ant-table-thead {
    border-bottom: 2px solid #eee;
    & > th > tr {
      ${appStyles.background.tableBgGray}
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 600;
      border: 1px solid #dededee3;
      &:before {
        display: none;
      }
    }
  }

  .card-name-tiles {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  & th.action-home {
    text-align: center !important;
  }
`;
